import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import styles from '../assets/css/route-check.module.css';
import { routeService } from '../services/routeService';
import CustomButtons from '../components/CustomButtons';

function RouteConfirmMyPage() {
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [applicant, setApplicant] = useState('');
  const [address, setAddress] = useState('');
  const [routes, setRoutes] = useState([]);
  const [busRequired, setBusRequired] = useState('');
  const [walkingImpossible, setWalkingImpossible] = useState('');
  const [attachmentURL, setAttachmentURL] = useState(null);

    useEffect(() => {
    const fetchRouteInfo = async () => {
      try {
        const data = await routeService.getRegistration();

        const {
          applicant,
          address,
          busRequired,
          walkingImpossible,
          attachmentURL,
          routes: routeList
        } = data;

      setApplicant(applicant);
      setAddress(address);
      setRoutes(routeList);
      setBusRequired(busRequired ? 'はい' : 'いいえ');
      setWalkingImpossible(walkingImpossible ? 'はい' : 'いいえ');
      setAttachmentURL(attachmentURL || null);
    } catch (err) {
      console.error('交通経路情報の取得に失敗:', err);
      setError('交通経路情報の取得に失敗しました');
    }
  };

  fetchRouteInfo();
}, []);

  const totalCost = routes.reduce((sum, r) => sum + (Number(r.commuterPassCost) || 0), 0);


  return (
    <div className={styles.container}>
      <h1 className={`${styles["text-primary"]} text-center mb-4`}>交通経路確認</h1>
      
      {/* エラーメッセージ表示 */}
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {/* 基本情報 */}
      <h2 className={styles["section-title"]}>基本情報</h2>
      <table className={styles["details-table"]}>
        <tbody>
          <tr><th>申請者</th><td>{applicant}</td></tr>
          <tr><th>現住所</th><td>{address}</td></tr>
        </tbody>
      </table>

      {/* 交通経路 */}
      <h2 className={styles["section-title"]}>交通経路情報</h2>
      <table className={styles["details-table"]}>
        <thead>
          <tr>
            <th>交通機関名</th>
            <th>発駅</th>
            <th>着駅</th>
            <th>片道料金</th>
            <th>定期代</th>
          </tr>
        </thead>
        <tbody>
          {routes.map((route, index) => (
            <tr key={index}>
              <td>{route.routeName}</td>
              <td>{route.fromStation}</td>
              <td>{route.toStation}</td>
              <td>{route.oneWayCost}円</td>
              <td>{route.commuterPassCost}円</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 利用状況 */}
      <h2 className={styles["section-title"]}>利用状況</h2>
      <p>バス利用: <strong>{busRequired}</strong></p>
      <p>徒歩困難（※直線距離で2kmを超える場合）: <strong>{walkingImpossible}</strong></p>

      {/* 交通費総額 */}
      <h2 className={styles["section-title"]}>交通費総額</h2>
      <p><strong>{totalCost}円</strong></p>

      {/* 添付ファイル */}
      <h2 className={styles["section-title"]}>添付ファイル</h2>
      {attachmentURL ? (
        <div className={styles["route-image"]}>
          <img src={attachmentURL} alt="添付ファイル" className={styles["route-map"]} />
        </div>
      ) : (
        <p>添付ファイルはありません。</p>
      )}

      {/* ボタン */}
        <CustomButtons
          leftLabel="戻る"
          rightLabel="編集する"
          onLeftClick={() => window.history.back()}
          onRightClick={() => navigate('/edit-route-registration', {
          state: {
            applicant,
            address,
            busRequired,
            walkingImpossible,
            routes,
            attachmentURL
          }
        })}
      />
    </div>
  );
}

export default RouteConfirmMyPage;